import { SpinningLoader } from '@frontend/design-system';
import { ListsCenteredContainer } from './lists-centered-container';

export const ListsLoadingState = () => (
  <ListsCenteredContainer>
    <SpinningLoader />
  </ListsCenteredContainer>
);
